import React from 'react';
import ReactDOM from 'react-dom/client';
import * as ReactRouterDOM from 'react-router-dom';

import App from './App';

if (typeof window !== 'undefined') {
  window.__SKI_PASS_APP__ = App;
  window.React = React;
  window.ReactDOM = ReactDOM;
  window.ReactRouterDOM = ReactRouterDOM;
}

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
